if (!customElements.get('judgeme-reviews-drawer')) {
  class JudgemeReviewsDrawer extends HTMLElement {
    constructor() {
      super();
      this.buttonEl = null;
    }

    connectedCallback() {
      this.buttonEl = this.querySelector('.judgeme-reviews-drawer__button');

      if (this.buttonEl) {
        this.buttonEl.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('panel:close', { bubbles: true }));
        });
      }

      this.layoutReviewsRow();
      this.syncCombinedBadge();

      if (!window.__bbjJudgemeBadgeListener) {
        window.__bbjJudgemeBadgeListener = true;
        document.addEventListener('click', this.handleBadgeClick.bind(this), true);
      }
    }

    syncCombinedBadge() {
      const combinedCount = parseInt(this.dataset.combinedCount || '0', 10);
      const combinedRating = parseFloat(this.dataset.combinedRating || '0');
      if (!combinedCount || combinedRating <= 0) return;

      const badge = document.querySelector('.product-information--inner .jdgm-preview-badge');
      if (!badge) return;

      let prevBadge = badge.querySelector('.jdgm-prev-badge');
      if (!prevBadge) {
        prevBadge = document.createElement('div');
        prevBadge.className = 'jdgm-prev-badge';
        prevBadge.dataset.numberOfQuestions = '0';
        prevBadge.innerHTML =
          '<span class="jdgm-prev-badge__stars" tabindex="0" role="button" aria-hidden="true"></span>' +
          '<span class="jdgm-prev-badge__text"></span>';
        badge.appendChild(prevBadge);
      }

      prevBadge.style.display = '';
      prevBadge.dataset.averageRating = this.dataset.combinedRating;
      prevBadge.dataset.numberOfReviews = String(combinedCount);

      const stars = prevBadge.querySelector('.jdgm-prev-badge__stars');
      if (stars) {
        stars.dataset.score = this.dataset.combinedRating;
        stars.setAttribute('aria-label', `${this.dataset.combinedRating} stars`);
      }

      const text = prevBadge.querySelector('.jdgm-prev-badge__text');
      if (text) {
        const template = window.jdgmSettings?.badge_n_reviews_text;
        if (template && template.includes('{{ n }}')) {
          text.textContent = template.replace(/\{\{\s*n\s*\}\}/g, String(combinedCount));
        } else {
          text.textContent = combinedCount === 1 ? '1 review' : `${combinedCount} reviews`;
        }

        if (window.jdgmSettings?.badge_hide_text) {
          text.style.display = 'none';
        }
      }

      this.renderSummaryStarsWhenReady();
      this.updateReviewsTriggerRating();
    }

    layoutReviewsRow() {
      const combinedCount = parseInt(this.dataset.combinedCount || '0', 10);
      const combinedRating = parseFloat(this.dataset.combinedRating || '0');
      const trigger = document.getElementById('ProductReviewsTrigger');
      const wishlistRow = document.querySelector('.product-wishlist-reviews-row');
      if (!trigger || !wishlistRow) return;

      if (!combinedCount || combinedRating <= 0) {
        trigger.hidden = true;
        return;
      }

      let badgeHost = wishlistRow.nextElementSibling;
      if (
        !badgeHost?.classList.contains('shopify-app-block') ||
        !badgeHost.querySelector('.jdgm-preview-badge')
      ) {
        badgeHost = document.querySelector(
          '.product-information--inner .shopify-app-block:has(.jdgm-preview-badge)'
        );
      }

      if (badgeHost && !trigger.contains(badgeHost)) {
        trigger.insertBefore(badgeHost, trigger.querySelector('.product-reviews-trigger__rating'));
      }

      this.updateReviewsTriggerRating();
      trigger.hidden = false;
    }

    updateReviewsTriggerRating() {
      const combinedCount = parseInt(this.dataset.combinedCount || '0', 10);
      const combinedRating = parseFloat(this.dataset.combinedRating || '0');
      const trigger = document.getElementById('ProductReviewsTrigger');
      if (!trigger || !combinedCount || combinedRating <= 0) return;

      const ratingEl = trigger.querySelector('.product-reviews-trigger__rating');
      if (!ratingEl) return;

      ratingEl.textContent = this.dataset.combinedRating;
      trigger.setAttribute(
        'aria-label',
        `${this.dataset.combinedRating} ${window.jdgmSettings?.rating_suffix || 'out of 5'}. ${trigger.querySelector('.product-reviews-trigger__label')?.textContent || ''}`
      );
    }

    renderSummaryStarsWhenReady(maxAttempts = 40) {
      const fillFallbackStars = () => {
        const stars = document.querySelector(
          '.product-information--inner .jdgm-prev-badge__stars'
        );
        if (!stars || stars.children.length > 0) return;

        const rating = parseFloat(this.dataset.combinedRating || '0');
        if (!rating) return;

        for (let i = 1; i <= 5; i += 1) {
          const star = document.createElement('span');
          star.className = `jdgm-star jdgm--${i <= Math.round(rating) ? 'on' : 'off'}`;
          stars.appendChild(star);
        }
      };

      const render = () => {
        if (window.jdgm && typeof window.jdgm.customize === 'function') {
          window.jdgm.customize();
          return true;
        }
        return false;
      };

      if (render()) return;

      let attempts = 0;
      const poll = window.setInterval(() => {
        attempts += 1;
        if (render() || attempts >= maxAttempts) {
          window.clearInterval(poll);
          if (attempts >= maxAttempts) {
            fillFallbackStars();
          }
        }
      }, 100);
    }

    handleBadgeClick(event) {
      const badge = event.target.closest('.jdgm-preview-badge, .product-reviews-trigger');
      if (!badge) return;

      const productInfo = badge.closest('.product-information--inner');
      if (!productInfo) return;

      event.preventDefault();
      event.stopPropagation();

      document.querySelector('judgeme-reviews-drawer')?.open();
    }

    open() {
      document.body.classList.add('open-cc');
      this.classList.add('active');
      this.focus();
      this.renderSummaryStarsWhenReady();
    }
  }

  customElements.define('judgeme-reviews-drawer', JudgemeReviewsDrawer);
}
